app.controller("syllabusIndexController", ["$scope", "Students", "ProgramService", "SyllabusService", "GradeTemplate", "Subject", "Lecturer", "StaticData", "$uibModal",
    function ($scope, Students, ProgramService, SyllabusService, GradeTemplate, Subject, Lecturer, StaticData, $uibModal) {
        $scope.subject;
        $scope.credits;
        $scope.lecturer;
        $scope.phone;
        $scope.email;
        $scope.level;
        $scope.purpose;
        $scope.result;
        $scope.mainLiterature;
        $scope.supportingLiterature;
        $scope.lectureTime;
        $scope.seminarTime;
        $scope.laboratoryTime;
        $scope.quizzes;
        $scope.exam;
        $scope.homework;
        $scope.goal;
        $scope.subjects = [];
        $scope.gradeTemplate = 'ძირითადი';
        $scope.tinymceOptions = {
            plugins: 'link image code table',
            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code | table'
        };

        $scope.$watch('subject', function (value) {
            if (value && value._id) {
                $scope.credits = value.credits;

                if (value.gradeTemplate) {
                    GradeTemplate.one(value.gradeTemplate).then(function (data) {
                        $scope.gradeTemplate = data.name;
                    })
                }

                if (value.prerequisites.length) {
                    var prerequisites = value.prerequisites;
                    for (var i in prerequisites) {
                        Subject.fetchOne(prerequisites[i]).then(function (data) {

                            $scope.subjects.push(data.subject)
                        })
                    }
                }

                if (value.level) {
                    $scope.level = value.level;
                }
            }
        });

        $scope.$watch('lecturer', function (value) {
            if (value && value._id) {
                $scope.phone = value.user.phone;
                $scope.email = value.user.email;
            }
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = levels;
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            return ProgramService.list({query: name}).then(function (data) {
                return data.docs;
            });
        };

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query}).then(function (data) {
                return data.docs.filter(function (subj) {
                    var el_index = _.findIndex($scope.dependencies, function (dependency) {
                        return dependency._id === subj._id;
                    });

                    if ($scope.chosenSubject && $scope.chosenSubject._id === subj._id) {
                        return false;
                    }

                    return el_index === -1;
                })
            });
        };

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.add = function () {
            // $uibModal.open({
            //     controller: "UploadSyllabusController",
            //     templateUrl: _pb + 'admin/syllabus/upload.html',
            //     size: "md",
            //     backdrop: 'static',
            // }).result.then(function (result) {
            //     console.log(result);
            //     $scope.syllabus = result;
            // }, function () {
            // });
        };

        $scope.save = function () {
            SyllabusService.save({
                subjectId: $scope.subject._id,
                syllabus: {
                    lectureTime: $scope.lectureTime,
                    seminarTime: $scope.seminarTime,
                    laboratoryTime: $scope.laboratoryTime,
                    quizzes: $scope.quizzes,
                    exam: $scope.exam,
                    homework: $scope.homework,
                    goal: $scope.goal
                }
            }).then(function (result) {
                toastr.success('', 'სილაბუსი შენახულია');
                console.log(result)
            })

        };
    }
]);
